import { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { SITE, WHATSAPP_LINK } from "../data/siteConfig";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkClass = ({ isActive }) =>
    `nav-link rs-nav-link ${isActive ? "active" : ""}`;

  const closeMenu = () => setCollapsed(true);

  return (
    <nav
      className={`navbar navbar-expand-lg rs-navbar ${scrolled ? "scrolled" : ""}`}
      data-testid="main-navbar"
    >
      <div className="container">
        <Link
          to="/"
          className="navbar-brand rs-brand"
          onClick={closeMenu}
          data-testid="brand-link"
        >
          <span className="rs-brand-mark">PC</span>
          <span>
            {SITE.brand}
            <span className="rs-brand-sub">Advisory · Compliance · Training</span>
          </span>
        </Link>

        <button
          className="navbar-toggler border-0"
          type="button"
          aria-label="Toggle navigation"
          onClick={() => setCollapsed((v) => !v)}
          data-testid="navbar-toggler"
        >
          <i className={`bi ${collapsed ? "bi-list" : "bi-x-lg"} fs-3`}></i>
        </button>

        <div
          className={`collapse navbar-collapse ${collapsed ? "" : "show"}`}
          id="rsNavContent"
        >
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink
                to="/"
                end
                className={linkClass}
                onClick={closeMenu}
                data-testid="nav-link-home"
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/about"
                className={linkClass}
                onClick={closeMenu}
                data-testid="nav-link-about"
              >
                About
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/services"
                className={linkClass}
                onClick={closeMenu}
                data-testid="nav-link-services"
              >
                Services
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/contact"
                className={linkClass}
                onClick={closeMenu}
                data-testid="nav-link-contact"
              >
                Contact
              </NavLink>
            </li>
          </ul>

          <div className="rs-nav-cta">
            <a
              href={SITE.phoneHref}
              className="btn rs-nav-call"
              data-testid="nav-call-btn"
            >
              <i className="bi bi-telephone-fill"></i>
              <span className="d-none d-xl-inline">Call</span> {SITE.phone}
            </a>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noreferrer"
              className="btn rs-nav-wa"
              data-testid="nav-whatsapp-btn"
            >
              <i className="bi bi-whatsapp"></i> WhatsApp
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
